import {Card} from 'primereact/card';
import PropTypes from 'prop-types';
import React from 'react';
import ActionLink from '../components/ActionLink';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import BlockUi from '../components/waitPanel/BlockUi';
import BaseContainer from './BaseContainer';
import AppPrefixUtils from '../utils/AppPrefixUtils';
import BaseBreadCrumb from './BaseBreadCrumb';
import CompanyAgreementBanner from '../components/CompanyAgreementBanner';
import {t} from 'i18next';
import FloatingButton from '../containers/action/TourButton';
import Tour from 'reactour';
import InputLanguageDropdownComponent from '../components/inputs/InputLanguageDropdownComponent';

class BaseDetailsContainer extends BaseContainer {
    constructor(props, service) {
        super(props);
        this.currentStep=0;
        this.steps=[];
        this.tourRef=React.createRef();
        this.service = service;
        this.onUpload = this.onUpload.bind(this);
        this.addBackAndEditButton = this.addBackAndEditButton.bind(this);
        this.addCancelAndSaveButtons = this.addCancelAndSaveButtons.bind(this);
        this.prepareCancelButton = this.prepareCancelButton.bind(this);
        this.prepareBackLink = this.prepareBackLink.bind(this);
        this.updateElement = this.updateElement.bind(this);
        this.createOrUpdate = this.createOrUpdate.bind(this);
        this.getAddSucces = this.getAddSucces.bind(this);
        this.getUpdateSucces = this.getUpdateSucces.bind(this);
        this.renderBackLink = this.renderBackLink.bind(this);
        this.getBackLabel = this.getBackLabel.bind(this);
        this.renderDetails = this.renderDetails.bind(this);
        this.renderView = this.renderView.bind(this);
        this.handleFileCountExceeded = this.handleFileCountExceeded.bind(this);
        this.onRemoveAction = this.onRemoveAction.bind(this);
        this.showRemoveConfirmation = this.showRemoveConfirmation.bind(this);
        this.hideRemoveConfirmation = this.hideRemoveConfirmation.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
        this.renderLanguages = this.renderLanguages.bind(this);
        this.goBackUrl = this.goBackUrl.bind(this);
        this.viewMode = this.viewMode.bind(this);
        this.showTour=this.showTour.bind(this);
        this.closeTour=this.closeTour.bind(this);
        this.backLinkRendered = true;
        this.state = {
            steps:[],
            isTourOpen: false,
        };
        if (service !== undefined && service !== null) {
            this.service.setUiMethods(this.blockUi, this.unblockUi, this.props.updateApp);
        }
    }
    viewMode() {}
    showTour(){
        this.setState(
            {
                isTourOpen: true,                
            }            
        );
    }
    closeTour(){
        this.setState(
            {
                isTourOpen: false,                
            }            
        );
    }
    // TO OVERIDE IF NECCESSARY
    canViewTour(){
        return false;
    }
    // TO OVERIDE
    initSteps(){}

    componentDidMount() {
        super.componentDidMount();
        this.blockUi();
        this.initBeforeSetElement();
        this.setElement();
        this.readMessage();
    }

    readMessage() {
        const messageFromStorage = this.readCookie(this.getContainerListName());
        if (messageFromStorage !== undefined && messageFromStorage != null) {
            const message = JSON.parse(messageFromStorage);
            this.removeCookie(this.getContainerListName());
            if (
                message.severity !== undefined &&
                message.severity != null &&
                message.summary !== undefined &&
                message.summary != null &&
                message.detail !== undefined &&
                message.detail != null
            ) {
                this.showMessage(message.severity, message.summary, message.detail);
            }
        }
    }

    changeLanguage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale));
        this.beforeUpdateElement('VIEW', elementId, locale);
    }

    renderLanguages() {
        return (
            <InputLanguageDropdownComponent
                id='supportedLocales'
                name='supportedLocales'
                label={t('global.LanguageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                colClass='col-lg-2 col-md-3 col-sm-3'
                viewMode={'EDIT'}
                onChange={this.changeLanguage}
                rendered
                stateField=''
                showClear={false}
            />
        );
    }

    showRemoveConfirmation() {
        this.setState({showConfirmRemoveDialog: true});
    }

    hideRemoveConfirmation() {
        this.setState({showConfirmRemoveDialog: false});
    }

    onRemoveAction(type, costam, target) {
        if (target.value) {
            this.blockUi();
            this.service
                .remove(this.state.element)
                .then(() => {
                    this.persistMessage('success', '', this.getRemoveSucces());
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(this.props.backUrl));
                })
                .catch((err) => {
                    this.showErrorMessage(err.message);
                    this.hideRemoveConfirmation();
                });
        } else {
            this.hideRemoveConfirmation();
        }
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId} = this.state;

        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();

            this.service
                .get(elementId, viewMode)
                .then((data) => {
                    this.setState({loading: false}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    handleGetDetailsError(err) {
        this.showErrorMessage(t('error.getDetailsError'));
        if (this.props.backUrl) {
            // window.location.href = AppPrefixUtils.locationHrefUrl(this.props.backUrl);
            this.props.history.push(AppPrefixUtils.locationHrefUrl(this.props.backUrl));
        } else {
            this.setState({loading: false}, () => this.unblockUi());
        }
    }
    prepareDataToUpdateElement(data) {
        return data;
    }
    updateElement(data) {
        if (this._isMounted) {
            this.setState(
                {
                    element: this.prepareDataToUpdateElement(data),
                },
                () => this.initAfterSetElement()
            );
        }
    }

    initAfterSetElement() {
        this.unblockUi();
    }

    initBeforeSetElement() {}

    onUpload(event, varName) {
        const {element} = this.state;
        const varValue = JSON.parse(event.xhr.response);
        if (this._isMounted) {
            const modifiedList = element[varName].concat(varValue);
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    [varName]: modifiedList,
                },
            }));
        }
    }

    handleFileCountExceeded(max) {
        this.showInfoMessage(t('message.maxCountAttachedFiles'), 10000);
        this.scrollToTop();
    }

    getAddSucces() {
        return t('message.elementCreated');
    }

    getUpdateSucces() {
        return t('message.elementActualized');
    }

    getRemoveSucces() {
        return t('message.elementRemoved');
    }

    getContainerListName() {
        return 'list-container';
    }

    persistMessage(severity, summary, detail) {
        this.saveCookie(
            this.getContainerListName(),
            JSON.stringify({
                severity,
                summary,
                detail,
            })
        );
    }

    handleValidForm() {
        this.createOrUpdate();
    }
    afterAddSuccess(response) {
        const {backUrl} = this.props;
        this.blockUi();
        this.persistMessage('success', '', this.getAddSucces(response));
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(backUrl);
    }
    afterUpdateSuccess(response) {
        const {backUrl} = this.props;
        this.blockUi();
        this.persistMessage('success', '', this.getUpdateSucces(response));
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(backUrl);
    }

    afterDeleteSuccess(response) {
        const {backUrl} = this.props;
        this.blockUi();
        this.persistMessage('success', '', this.getRemoveSucces(response));
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(backUrl);
    }
    prepareElementBeforeRequest(element) {
        return element;
    }
    createOrUpdate() {
        const {element} = this.state;
        const request = this.prepareElementBeforeRequest(element);
        this.scrollToTop();
        if (this._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }

    addBackAndEditButton(backLabel) {
        const {editUrl, viewMode} = this.props;
        const {element} = this.state;
        const buttons = [
            this.prepareBackLink(backLabel),
            {
                label: 'Edytuj',
                className: 'float-right',
                // href: AppPrefixUtils.locationHrefUrl(`${editUrl}/${element.id}`),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(`${editUrl}/${element.id}`));
                },
                rendered: viewMode === 'VIEW',
            },
        ];
        return this.prepareHeader(buttons);
    }

    prepareBackLink(backLabel) {
        const {backUrl} = this.props;
        return {
            label: backLabel,
            // href: AppPrefixUtils.locationHrefUrl(backUrl),
            onClick: () => {
                this.props.history.push(AppPrefixUtils.locationHrefUrl(`${backUrl}`));
            },
            type: 'LINK',
        };
    }

    prepareCancelButton() {
        const {backUrl, cancelUrl, viewMode} = this.props;
        const {element} = this.state;
        let goBackUrl;
        if (viewMode === 'NEW') {
            goBackUrl = backUrl;
        } else {
            goBackUrl = `${cancelUrl}/${element.id}`;
        }
        return {
            label: 'Anuluj',
            // href: AppPrefixUtils.locationHrefUrl(goBackUrl),
            onClick: () => {
                this.props.history.push(AppPrefixUtils.locationHrefUrl(`${goBackUrl}`));
            },
            className: 'cancel-button gray',
        };
    }

    addCancelAndSaveButtons() {
        const buttons = [
            this.prepareCancelButton(),
            {
                label: 'Zapisz',
                className: 'float-right',
                onClick: this.handleFormSubmit,
            },
        ];
        return this.prepareFooter(buttons);
    }

    getBackLabel() {
        return t('global.back');
    }

    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        const {backUrl} = this.props;
        // window.location.href = AppPrefixUtils.locationHrefUrl(backUrl);
        this.props.history.push(backUrl);
    }

    renderBackLink() {
        return (
            <ActionLink
                rendered={this.backLinkRendered}
                label={this.getBackLabel()}
                className='p-link back-blue-link float-right'
                handleClick={this.handleGoBack.bind(this)}
                variant='blue'
                iconName='mdi-arrow-left'
                iconSide='left'
                iconSize='xs'
                iconColor='blue'
            />
        );
    }

    prepareEditButton(rendered, label) {
        const {editUrl} = this.props;
        const {element} = this.state;
        return {
            label: label !== undefined ? label : t('global.edit'),
            type: 'BUTTON',
            variant: '',
            // href: AppPrefixUtils.locationHrefUrl(`${editUrl}/${element.id}`),
            onClick: () => {
                this.props.history.push(AppPrefixUtils.locationHrefUrl(`${editUrl}/${element.id}`));
            },
            rendered: rendered,
            iconName: 'mdi-pencil',
            iconSide: 'left',
            iconSize: 'm',
        };
    }
    goBackUrl() {
        const {backUrl, cancelUrl, viewMode} = this.props;
        const {element} = this.state;

        let goBackUrl;
        if (viewMode === 'NEW') {
            goBackUrl = backUrl;
        } else {
            goBackUrl = `${cancelUrl}/${element.id}`;
        }
        return goBackUrl;
    }
    cancelButtonLabel() {
        return 'Anuluj';
    }
    prepareFooterItems() {
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        switch (viewMode) {
            case 'EDIT':
            case 'NEW':
                return [
                    {
                        label: this.cancelButtonLabel(),
                        // href: AppPrefixUtils.locationHrefUrl(this.goBackUrl()),
                        onClick: () => {
                            this.props.history.push(AppPrefixUtils.locationHrefUrl(this.goBackUrl()));
                        },
                        className: 'cancel-button gray',
                    },
                    {
                        label: t('global.save'),
                        className: 'float-right',
                        onClick: this.handleFormSubmit,
                    },
                ];
            case 'VIEW':
            default:
                return [];
        }
    }

    renderDetails() {
        return null;
    }

    renderView() {
        return (
            <DivContainer colClass=''>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <CompanyAgreementBanner />
                    <BaseBreadCrumb items={this.breadCrumbItems()} />
                    {this.state.loading ? null : this.renderCard()}
                </BlockUi>
            </DivContainer>
        );
    }
    renderCard() {
        return (
            <Card className='details-card mt-2' footer={this.renderFooter()} header={this.renderHeader()}>
                <form onSubmit={this.handleFormSubmit} noValidate>
                    {this.canViewTour() ? (<FloatingButton onClick={this.showTour} />) : <span/>}
                    {this.renderDetails()}
                    {this.renderTour()}
                </form>
            </Card>
        );
    }
    renderTour(){
        return <Tour
                    steps={this.steps}
                    isOpen={this.state.isTourOpen}
                    onRequestClose={this.closeTour} 
                    nextStep={() => {
                        // Najpierw przewiń do elementu
                        const currentStep = this.currentStep;
                        const currentElement = document.querySelector(this.steps[currentStep].selector);
                        if (currentElement) {
                          currentElement.scrollIntoView({
                            behavior: 'auto', // lub 'auto' dla natychmiastowego przewijania
                            block: 'center',    // przewiń, aby element był wyśrodkowany
                          });
                          // Następnie przejdź do następnego kroku po krótkim opóźnieniu
                          setTimeout(() => {
                            this.tourRef.current?.nextStep();
                            console.log(`The current step is ${currentStep + 1}`);
                          }, 400); // 500 ms opóźnienia przed przejściem do następnego kroku
                        }
                      }}
                    prevStep={() => {
                        // Najpierw przewiń do elementu
                        const currentStep = this.currentStep;
                        const currentElement = document.querySelector(this.steps[currentStep].selector);
                    
                        if (currentElement) {
                          currentElement.scrollIntoView({
                            behavior: 'auto', // lub 'auto' dla natychmiastowego przewijania
                            block: 'center',    // przewiń, aby element był wyśrodkowany
                          });
                          // Następnie przejdź do następnego kroku po krótkim opóźnieniu
                          setTimeout(() => {
                            this.tourRef.current?.prevStep();
                            console.log(`The current step is ${currentStep + 1}`);
                          }, 400); // 500 ms opóźnienia przed przejściem do następnego kroku
                        }
                      }}
                    getCurrentStep={(step) => {
                        this.currentStep=step; // Ustaw currentStep przy zmianie kroku
                      }}
                    disableDotsNavigation={true}
                    ref={this.tourRef}
        />
    }
    renderHeader() {
        const headerItems = this.prepareHeaderItems();
        if (headerItems !== undefined && headerItems.length > 0 && headerItems.filter((f) => f.rendered !== false)?.length > 0) {
            return <React.Fragment>{this.prepareHeader(headerItems)}</React.Fragment>;
        } else {
            return null;
        }
    }

    renderViewWithoutCard() {
        return <DivContainer colClass=''>{this.state.loading ? null : this.renderDetails()}</DivContainer>;
    }
}

BaseDetailsContainer.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
};

BaseDetailsContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
};

export default BaseDetailsContainer;
